import _ from 'lodash'

export async function loadTemplate(fileName, lang = 'en', json = true) {
  const url = `${process.env.PUBLIC_URL}/${lang}-${fileName}.json?v=${process.env.REACT_APP_COMMIT_HASH}`

  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`)
  }

  return json ? response.json() : response.text()
}
